'use strict';

module Patersons {

    export class SpinnerComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/common/components/spinner.component.html';
    }
}